import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  TextField,
  Box,
  Button,
} from "@mui/material";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { East, West } from "@mui/icons-material";

const PackagingSection = ({
  handleNext,
  handleBack,
  emissionFactors,
  setTotalPackagingEmission,
  totalPackagingEmission,
}) => {
  const [boxType, setBoxType] = useState(null);
  const [amtPackagingUsed, setAmtPackagingUsed] = useState(null);
  const [packageElectricity, setPackageElectricity] = useState(null);

  console.log("factors", emissionFactors);
  useEffect(() => {
    const calculateEmission = () => {
      console.log("before:", totalPackagingEmission);
      let result = 0;

      if (
        !emissionFactors.Packaging ||
        !emissionFactors.Packaging.Electricity_used
      ) {
        result = 0;
      } else {
        result =
          emissionFactors.Packaging.Electricity_used * packageElectricity +
          emissionFactors.Packaging[boxType] * amtPackagingUsed;
      }
      setTotalPackagingEmission(result);
    };
    calculateEmission();
  }, [boxType, packageElectricity]);

  return (
    <Grid
      container
      fullWidth
      justifyContent="center"
      mx="auto"
      my="20%"
      borderRadius={4}
      p={3}
      xs={12}
      style={{
        boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
        background:
          "linear-gradient(to right bottom, #ffffff, #fdfdfe, #fafbfd, #f7f9fb, #f3f7fa",
      }}
    >
      <Grid item xs={12} flex>
        <Typography mb={4} variant="h4">
          Packaging
        </Typography>
      </Grid>

      <Grid container xs={12} flex fullWidth>
        <Grid item xs={12} md={6} py={2} px={4}>
          <Typography variant="h6">Packaging type</Typography>
          <Box mt={2}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Packaging type
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                value={boxType}
                label="Storage "
                onChange={(e) => {
                  setBoxType(e.target.value);
                }}
              >
                <MenuItem value={"Paperboard"}>
                  Paperboard or Corrugated boxes
                </MenuItem>
                <MenuItem value={"Jute"}>Jute bags</MenuItem>
                <MenuItem value={"HDPE"}>HDPE bags</MenuItem>
                <MenuItem value={"LDPE"}>LDPE bags</MenuItem>
                <MenuItem value={"Paper"}>Paper bags</MenuItem>
                <MenuItem value={"Cotton"}>Cotton Bags</MenuItem>
                <MenuItem value={"Plastic"}>Plastic boxes</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Grid>

        <Grid item xs={12} md={6} py={2} px={4}>
          <Typography variant="h6">
            Amount of Packaging Material Used
          </Typography>
          <Box mt={2}>
            <TextField
              fullWidth
              label="in kgs"
              variant="outlined"
              value={amtPackagingUsed}
              onChange={(event) => {
                setAmtPackagingUsed(event.target.value);
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6} py={2} px={4}>
          <Typography variant="h6">Electricity Used</Typography>
          <Box mt={2}>
            <TextField
              fullWidth
              label="in kWh"
              variant="outlined"
              value={packageElectricity}
              onChange={(event) => {
                setPackageElectricity(event.target.value);
              }}
            />
          </Box>
        </Grid>

        <Grid
          item
          flex
          xs={11}
          mx="auto"
          mb={8}
          px={4}
          sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none" } }}
        >
          <Box mx="auto">
            <Button
              variant="outlined"
              onClick={handleBack}
              startIcon={<West />}
              sx={{ mt: 1, ml: 1, width: "6rem" }}
            >
              Back
            </Button>
            <Button
              variant="contained"
              onClick={handleNext}
              endIcon={<East />}
              sx={{ mt: 1, ml: 2, width: "6rem" }}
            >
              Next
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PackagingSection;
